<template>
  <ajax-index
    :order-call-back="orderCallBack"
    :uri="uri"
    :event-id="uidAjaxTable"
    :render-mode="isList ? 'list' : isTable ? 'table' : 'mosaic'"
    :entity-name="name"
    :config="config"
    auth="oauth.access_token"
  >
    <b-row slot="list-header">
      <b-col v-if="canCreate" class="mb-4">
        <b-btn
          block
          variant="primary"
          size="sm"
          @click="openModal(modalName('new'))"
        >
          {{ $t(`pages.${name}.new`) }}
        </b-btn>
      </b-col>
      <slot name="header-actions" />
    </b-row>
    <template v-if="isTable">
      <template slot="table-title">
        <slot name="title" />
      </template>
      <template slot="header">
        <slot name="table-header" />
      </template>
    </template>
    <template slot="item" slot-scope="ctx">
      <template v-if="isList">
        <b-list-group-item :class="{'to-verify': !itemEnabled(ctx.item)}">
          <template v-if="canManage">
            <div class="float-right item-actions">
              <b-moderate
                v-if="isModerated"
                :item="ctx.item"
                :name="name"
                :uid="uid"
              />
              <b-button
                variant="info"
                size="sm"
                @click="openModal(modalName('edit'), ctx.item)"
              >
                <i class="ti ti-edit" />
              </b-button>
              <b-button
                variant="danger"
                size="sm"
                @click="openModal(modalName('delete'), ctx.item)"
              >
                <i class="ti ti-trash" />
              </b-button>
            </div>
          </template>
          <slot :item="ctx.item" name="list-content">
            <span class="red-text step-title">
              {{ ctx.item.created_at | moment('LL') }} : {{ $helper.demoFallbackTranslation(ctx.item, 'title') }}
            </span>
            <div class="clearfix" />
            <p>{{ $helper.demoFallbackTranslation(ctx.item, 'text') }}</p>
          </slot>
        </b-list-group-item>
      </template>
      <template v-else-if="isTable">
        <tr :class="{'to-verify': !itemEnabled(ctx.item)}" class="table-item">
          <slot :item="ctx.item" name="table-content">
            <td>{{ ctx.item }}</td>
            <template v-if="canManage">
              <td>
                <b-moderate
                  v-if="isModerated"
                  :item="ctx.item"
                  :name="name"
                  :uid="uid"
                />
                <b-button
                  variant="info"
                  size="sm"
                  @click="openModal(modalName('edit'), ctx.item)"
                >
                  <i class="ti ti-edit" />
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  @click="openModal(modalName('delete'), ctx.item)"
                >
                  <i class="ti ti-trash" />
                </b-button>
              </td>
            </template>
          </slot>
        </tr>
      </template>
      <template v-else>
        <b-col :md="mosaicCols" sm="4">
          <div :class="{'to-verify': !itemEnabled(ctx.item)}" class="mosaic-item">
            <template v-if="canManage">
              <div class="float-right item-actions">
                <b-moderate
                  v-if="isModerated"
                  :item="ctx.item"
                  :name="name"
                  :uid="uid"
                />
                <b-button
                  variant="info"
                  size="sm"
                  @click="openModal(modalName('edit'), ctx.item)"
                >
                  <i class="ti ti-edit" />
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  @click="openModal(modalName('delete'), ctx.item)"
                >
                  <i class="ti ti-trash" />
                </b-button>
              </div>
              <div class="clearfix" />
            </template>
            <slot :item="ctx.item" name="mosaic-content">
              <span class="red-text step-title">{{ ctx.item.title }}</span>
            </slot>
          </div>
        </b-col>
      </template>
    </template>
    <template slot="modal">
      <template v-if="canCreate">
        <e-modal :event-id="modalName('new')" :title="$t(`pages.${name}.new`)">
          <ajax-new
            :close-modal="true"
            :ref-modal="modalName('new')"
            :refresh-ajax-index="true"
            :ref-ajax-index="uidAjaxTable"
            :load-on-mount="false"
            :name="name"
            :uri="getModalUriCreate"
            :notification-success-text="getNotificationSuccessText"
            :config="config"
          >
            <template
              v-if="hasPaypal"
              slot="submitButton"
            >
              <p class="text-center"><small>{{ $t('pages.memorial.paypal_info') }}</small></p>
              <paypal-button />
            </template>
          </ajax-new>
        </e-modal>
      </template>
      <template v-if="canManage">
        <e-modal :event-id="modalName('edit')" :title="$t(`pages.${name}.edit`)">
          <ajax-edit
            :close-modal="true"
            :ref-modal="modalName('edit')"
            :refresh-ajax-index="true"
            :ref-ajax-index="uidAjaxTable"
            :load-on-mount="false"
            :name="name"
            :uri="modalUri"
            :config="config"
          />
        </e-modal>
        <e-modal :event-id="modalName('delete')" :title="$t(`pages.${name}.delete`)">
          <ajax-delete
            :close-modal="true"
            :ref-modal="modalName('delete')"
            :refresh-ajax-index="true"
            :ref-ajax-index="uidAjaxTable"
            :load-on-mount="false"
            :name="name"
            :uri="modalUri"
          />
        </e-modal>
      </template>
    </template>
  </ajax-index>
</template>

<script>
  import AjaxEdit from '@triotech/vue-core/src/components/ajax/AjaxEdit';
  import AjaxDelete from '@triotech/vue-core/src/components/ajax/AjaxDelete';
  import AjaxNew from '@triotech/vue-core/src/components/ajax/AjaxNew';
  import AjaxIndex from '@triotech/vue-core/src/components/ajax/AjaxIndex';
  import EModal from '@/components/EModal';
  import BModerate from '@/components/ModerateButton';
  import PaypalButton from '@/components/PaypalButton';

  export default {
    name: 'EIndexComponent',
    components: {
      AjaxEdit,
      AjaxDelete,
      AjaxIndex,
      AjaxNew,
      EModal,
      BModerate,
      PaypalButton,
    },
    props: {
      credentials: {
        type: Object,
        default: () => ({}),
      },
      mode: {
        type: String,
        default: 'list',
      },
      canCreate: {
        type: Boolean,
        default: true,
      },
      canManage: {
        type: Boolean,
        default: false,
      },
      uri: {
        type: String,
        default: '',
      },
      hasPaypal: {
        type: Boolean,
        default: false,
      },
      isModerated: {
        type: Boolean,
        default: true,
      },
      name: {
        type: String,
        default: '',
      },
      modalUri: {
        type: String,
        default: '',
      },
      modalUriCreate: {
        type: String,
        default: null,
      },
      orderCallBack: {
        type: Function,
        default: list => list,
      },
      mosaicCols: {
        type: Number,
        default: 3,
      },
      config: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        // eslint-disable-next-line no-underscore-dangle
        uid: this._uid,
      };
    },
    computed: {
      uidAjaxTable() {
        return `ajax-table-${this.uid}`;
      },
      getModalUriCreate() {
        return this.modalUriCreate !== null ? this.modalUriCreate : this.modalUri;
      },
      isList() {
        return this.mode === 'list';
      },
      isTable() {
        return this.mode === 'table';
      },
      // eslint-disable-next-line consistent-return
      getNotificationSuccessText() {
        if (!!this.get().memorial && !this.get().memorial.moderate_after) {
          return this.$t(`flashes.${this.name}.pending_moderation`);
        }
      },
    },
    methods: {
      modalName(action) {
        return `${this.name}-${action}-${this.uid}`;
      },
      openModal(id, data = null) {
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
      itemEnabled(item) {
        return !_.isNil(item.enabled) ? item.enabled : true;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  .mosaic-item {
    padding: 10px;
    border: 1px solid $light-grey;
    border-radius: 4px;
    word-break: break-all;
    margin: 10px 0;

    &.to-verify {
      border-color: $red;
    }
  }

  .item-actions {
    margin-bottom: 10px;
  }

  /deep/ .list-group {
    position: relative;
    margin-top: 2em;

    .list-group-item {
      margin: 1em 0;

      &.to-verify {
        border: 1px solid $red;
      }

      .step-title {
        display: block;
        margin-bottom: 1.5em;
      }

      p {
        color: $grey;
      }
    }
  }

  @include editable-max-width(575px) {
    /deep/ .list-group {
      margin-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EIndex.vue